<template>
    <div>
      <el-form-item label="题干" class="exr-type-subject">
        <el-radio-group v-model="config.subject">
          <el-radio-button label="words">词汇</el-radio-button>
          <el-radio-button label="line">单行文本</el-radio-button>
          <el-radio-button label="text">多行文本</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="元素">
        <el-checkbox border v-model="config.subjectPinyin" label="有拼音" v-if="config.subject"></el-checkbox>
        <el-checkbox border v-model="config.image" label="有图片"></el-checkbox>
      </el-form-item>
      <el-form-item label="模式">
        <el-radio-group v-model="config.mode">
          <el-radio-button :label="0">默认</el-radio-button>
          <el-radio-button :label="1">跟读</el-radio-button>
          <el-radio-button :label="2">复述</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="答题解析">
        <el-checkbox border v-model="config.showReviewsContent" label="内容说明"></el-checkbox>
        <el-checkbox border v-model="config.showReviewsGrammar" label="关联语法"></el-checkbox>
      </el-form-item>
      <el-form-item label="AI超解析">
        <el-radio-group v-model="config.aiChao">
          <el-radio-button :label="0">没有小超</el-radio-button>
          <el-radio-button :label="1">有小超没有解析</el-radio-button>
          <el-radio-button :label="2">有小超有解析</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="翻译按钮">
        <el-checkbox border v-model="config.translatable.subject" label="题干可翻译" :false-label="0" :true-label="1"></el-checkbox>
      </el-form-item>
    </div>
</template>

<script>
export default {
  name: 'lyt',
  data () {
    return {
      config: {
        subject: 'line',
        subjectPinyin: true,
        image: false,
        mode: 1,
        showReviewsContent: false,
        showReviewsGrammar: false,
        aiChao: 0,
        translatable: {},
      }
    }
  }
}
</script>